import { MdCardMembership ,MdOutlineSecurity} from "react-icons/md";
import {RiQuestionnaireLine} from "react-icons/ri";
import {AiOutlineMail,AiOutlineUser} from "react-icons/ai";
import {BsThreeDots} from "react-icons/bs";

const faqsTabItem = [
  {
    title: "Membership",
    eventKey: "membership",
    icon:<MdCardMembership/>
  },
  {
    title: "Questionnaire",
    eventKey: "questionnaire",
    icon:<RiQuestionnaireLine/>
    
  },
  {
    title: "AkçeUsage",
    eventKey: "akceUsage",
    icon:<MdCardMembership/>
  },
  {
    title: "Personal Info",
    eventKey: "personalInformation",
    icon:<AiOutlineUser/>
  },
  {
    title: "Communication",
    eventKey: "communication",
    icon:<AiOutlineMail/>
  },
  {
    title: "Security",
    eventKey: "security",
    icon:<MdOutlineSecurity/>
  },
  {
    title: "Other",
    eventKey: "other",
    icon:<BsThreeDots/>
  },
];

export default faqsTabItem;
